import { render } from "./activate.vue?vue&type=template&id=d0a89720"
import script from "./activate.js?vue&type=script&lang=js&external"
export * from "./activate.js?vue&type=script&lang=js&external"

import "./activate.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__